// removed by extract-text-webpack-plugin
module.exports = {"row_table":"components-tjcx-queryStudents-jhysQueryStudents-show-row_table-24IXW","col_left":"components-tjcx-queryStudents-jhysQueryStudents-show-col_left-2aj6w","col_right":"components-tjcx-queryStudents-jhysQueryStudents-show-col_right-1SZT2","blue":"components-tjcx-queryStudents-jhysQueryStudents-show-blue-3B1PR"};


//////////////////
// WEBPACK FOOTER
// ./components/tjcx/queryStudents/jhysQueryStudents/show.css
// module id = 823
// module chunks = 0